import { memo, ReactElement, useCallback } from 'react';
import { FilterChipProps } from './common';
import { BaseFilterChip } from './BaseFilterChip';
import { StringSelectFilterProps } from '../Primitives/StringSelectFilter';
import { useTranslation } from 'react-i18next';

export const StringSelectFilterChip = memo(function ({
  displayName,
  onValueChange,
  value,
}: FilterChipProps<StringSelectFilterProps>): ReactElement {
  const { t } = useTranslation();
  const handleRemove = useCallback(
    function (optionValue: string): void {
      if (onValueChange) {
        const newOptionValues = (value?.in || []).filter((v) => v !== optionValue);
        onValueChange(newOptionValues.length ? { in: newOptionValues } : undefined);
      }
    },
    [onValueChange, value]
  );

  return (
    <>
      {value &&
        value.in &&
        value.in.map((v, idx) => (
          <BaseFilterChip key={idx} onRemove={() => handleRemove(v)}>
            {t(displayName)}: {v}
          </BaseFilterChip>
        ))}
    </>
  );
});
